import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';
import data from "../../../../assets/apiRoutes.json";
import { PrimaryLayout } from './Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const handlePrimaryFormLoad = useCallback(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        // Use setTimeout to ensure formRefs are available after FormField renders
        setTimeout(() => {
            loadLookupClient("STATUS", statusOptions);
        }, 100);
    }, [loadLookupClient]);

    // Load Status dropdown when formRefs become available
    useEffect(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        loadLookupClient("STATUS", statusOptions);
    }, [loadLookupClient, props.formFields?.STATUS]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='8EA91CDE-B3B2-4C36-9966-C5C49E157189'
                layoutName='WMEvaluationExpressionPrimaryForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);

